<div class="col">
    <xcm-scope [scopes]="scopes$ | async" (onScopeSelected)="onScopeSelected($event)"></xcm-scope>                
</div>
<router-outlet></router-outlet>